// ========================================
// COMPOSANT LoadingScreen
// Écran de chargement
// ========================================

import React from 'react';
import './LoadingScreen.css';

const LoadingScreen = ({ message = 'Chargement...' }) => {
  return (
    <div className="loading-screen">
      <div className="loading-content">
        <div className="loading-logo">
          <span>GK</span>
        </div>
        <div className="loading-spinner-container">
          <div className="loading-spinner"></div>
        </div>
        <p className="loading-message">{message}</p>
      </div>
    </div>
  );
};

export default LoadingScreen;